export default __webpack_public_path__ + "static/media/Dual-band of the Blood God.d01ea17d.jpg";